<div class="items-wrapper">
  <div class="items-container" #container>
    <ng-container *ngFor="let item of visibleItems">
      <div class="item">
        <!-- <span>{{item.name}}</span> -->
       <span
        class="px-1">
            <app-button
        
                placement="bottom-left"
                class="primary-bg"
            
                imgUrl="/assets/SVGIcons/removeIcon.svg"
                [buttonLable]="item.name">
            </app-button>
        </span>
      </div>
    </ng-container>

    <div *ngIf="!expanded && hiddenCount > 0" class="count-indicator">
      +{{ hiddenCount }}
    </div>

      <div 
    class="toggle-btn" 
    *ngIf="items.length > 0" 
    (click)="toggleExpand()" 
    >
    {{ expanded ? 'Show Less' : 'Show All' }}
  </div>
  </div>

</div>
